(() => {
  const popup = document.getElementById('thokerco-signup-popup');
  if (!popup) return;

  const panel = popup.querySelector('.tc-signup-popup__panel');
  const email = popup.querySelector('#tc-signup-email');
  const success = popup.querySelector('.tc-signup-popup__success');
  const errors = popup.querySelector('.tc-signup-popup__errors');
  const inThemeEditor = popup.dataset.designMode === 'true';
  const storage = {
    get(key) { try { return window.localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { window.localStorage.setItem(key, value); } catch (_) {} }
  };
  const now = Date.now();
  const dismissedAt = Number(storage.get('tcSignupPopupDismissedAt') || 0);
  const dismissedRecently = dismissedAt && (now - dismissedAt) < 7 * 24 * 60 * 60 * 1000;
  let previousFocus = null;
  let isOpen = false;

  function openPopup() {
    if (isOpen) return;
    previousFocus = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-signup-popup-open');
    isOpen = true;
    window.requestAnimationFrame(() => {
      if (success) {
        popup.querySelector('[data-tc-popup-close]:not(.tc-signup-popup__backdrop)')?.focus();
      } else if (email) {
        email.focus({ preventScroll: true });
      } else {
        panel?.focus({ preventScroll: true });
      }
    });
  }

  function closePopup() {
    if (!isOpen) return;
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tc-signup-popup-open');
    isOpen = false;
    if (success) {
      storage.set('tcSignupPopupSubscribed', '1');
    } else if (!inThemeEditor) {
      storage.set('tcSignupPopupDismissedAt', String(Date.now()));
    }
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  }

  popup.querySelectorAll('[data-tc-popup-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }
    if (event.key === 'Tab') {
      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  if (success) {
    window.setTimeout(openPopup, inThemeEditor ? 300 : 500);
    return;
  }
  if (errors) {
    window.setTimeout(openPopup, 300);
    return;
  }
  if (!inThemeEditor && (storage.get('tcSignupPopupSubscribed') === '1' || dismissedRecently)) return;

  window.setTimeout(openPopup, inThemeEditor ? 700 : 4500);
})();